import { EndpointContract } from '../../architecture/ControllerContract';
import { z } from 'zod';

import { categoryBoundingBox } from '../Product';

const body = z
    .object({
        base64: z.string()
    })
    .strict();

export const identifyImageProductsResponse = z
    .object({
        id: z.string(),
        url: z.string().url(),
        width: z.number().int().positive(),
        height: z.number().int().positive(),
        boundingBoxes: z.array(categoryBoundingBox)
    })
    .strict();

export const identifyImageProducts = {
    verb: 'post',
    path: 'identify-image-products',
    schema: {
        body,
        response: {
            200: identifyImageProductsResponse
        }
    }
} as const satisfies EndpointContract;
export type IdentifyImageProductsRequest = z.infer<typeof body>;
export type IdentifyImageProductsResponse = z.infer<
    typeof identifyImageProductsResponse
>;
